import getActiveDashboardAlerts from './api/getActiveDashboardAlerts.service';
import registerDashboardAction from './api/registerDashboardAction.service';
import updateSftpConfig from './api/sftp/updateSftpConfig.service';

let host,
  validationsHost,
  bookingOauth,
  integrationHubHost,
  crossellHost,
  upsellHost,
  crossellFrontHost,
  upsellFrontHost,
  doorOpeningHost;

switch (process.env.REACT_APP_ENV) {
  case 'development':
    host = 'http://localhost:8001/';
    validationsHost = 'http://localhost:4000/';
    bookingOauth = 'http://localhost:3002/onboarding/auth';
    integrationHubHost = 'https://api.pre.civitfun.com/';
    crossellHost = 'https://cross-sell-api-staging.civitfun.com/';
    upsellHost = 'https://upsell-api-staging.civitfun.com/';
    crossellFrontHost = 'https://cross-sell-pre.civitfun.com/';
    upsellFrontHost = 'https://upsell-pre.civitfun.com/';
    doorOpeningHost = 'http://localhost:5173/';

    break;
  case 'preproduction':
    host = 'https://dashboard-api.pre.civitfun.com/';
    validationsHost = 'https://validation-onboarding-api.pre.civitfun.com/';
    bookingOauth = 'https://bookingdotcom.pre.civitfun.com/onboarding/auth';
    integrationHubHost = 'https://api.pre.civitfun.com/';
    crossellHost = 'https://cross-sell-api-staging.civitfun.com/';
    upsellHost = 'https://upsell-api-staging.civitfun.com/';
    crossellFrontHost = 'https://cross-sell-pre.civitfun.com/';
    upsellFrontHost = 'https://upsell-pre.civitfun.com/';
    doorOpeningHost = 'https://door-opening-staging.civitfun.com/';

    break;
  case 'staging':
    host = 'https://dashboard-api-staging.civitfun.com/';
    validationsHost = 'https://validation-onboarding-api-staging.civitfun.com/';
    bookingOauth = 'https://bookingdotcom.pre.civitfun.com/onboarding/auth'; // TODO set to staging
    integrationHubHost = 'https://integration-hub-staging.civitfun.com/';
    crossellHost = 'https://cross-sell-api-staging.civitfun.com/';
    upsellHost = 'https://upsell-api-staging.civitfun.com/';
    crossellFrontHost = 'https://cross-sell-pre.civitfun.com/';
    upsellFrontHost = 'https://upsell-pre.civitfun.com/';
    doorOpeningHost = 'https://door-opening-staging.civitfun.com/';

    break;
  case 'production':
  default:
    host = 'https://dashboard-api.civitfun.com/';
    validationsHost = 'https://validation-onboarding-api.civitfun.com/';
    bookingOauth = 'https://bookingdotcom.civitfun.com/onboarding/auth';
    integrationHubHost = 'https://api.civitfun.com/';
    crossellHost = 'https://cross-sell-api.civitfun.com/';
    upsellHost = 'https://upsell-api.civitfun.com/';
    crossellFrontHost = 'https://cross-sell.civitfun.com/';
    upsellFrontHost = 'https://upsell.civitfun.com/';
    doorOpeningHost = 'https://door-opening.civitfun.com/';

    break;
}
export default {
  host,
  validationsHost,
  crossellHost,
  upsellHost,
  crossellFrontHost,
  upsellFrontHost,
  doorOpeningHost,
  integrationHubHost,
  URIs: {
    auth: {
      login: 'auth/login',
      validateLogin: 'auth/validate-login',
      register: 'auth/register',
      registerPaperless: 'auth/register-paperless',
      validateUser: 'auth/validate-user',
      validatePassword: 'auth/validate-password',
      superUser: {
        chains: 'auth/superuser/:userId/chains',
        impersonateLogin: 'auth/superuser/:userId/impersonate-login',
      },
      recoverPassword: 'auth/recover-pass',
      changePassword: 'auth/change-pass',
      loggedChangePassword: 'auth/logged-change-pass',
      activateOtaAccount: 'auth/activate-ota-account',
      paymentMethodConfigured: 'auth/payment-method-configured',
    },
    checkOut: {
      getCheckOuts: 'checkouts',
      getSubscriptionStatus: 'checkouts/:hotelId/subscription-status',
    },
    guestlink: {
      getTemplatesAndSubjects: 'guestlink/:hotelId/default-templates',
    },
    doorOpening: {
      setDoorOpeningOauth: 'doors/config-oauth',
    },
    oauth: {
      getOauth: 'get-oauth',
    },
    validations: {
      checkin: 'val/:hotelId/checkin/:action',
      PDFGeneration: 'val/:hotelId/PDFGeneration',
      connection: 'val/:hotelId/connection',
      generateEmail: 'val/:hotelId/check/mail',
      guest: 'val/:hotelId/guest/:action',
      paperless: 'val/:hotelId/paperless/:action',
      payments: 'val/:hotelId/payments/:action',
      onboarding: 'val/:hotelId/onboarding/:action',
      searches: 'val/:hotelId/searches/:action',
    },
    hotelSlug: 'hotel/:hotelId/slug',
    chainSlug: 'chain/:chainId/slug',
    checkins: 'checkins',
    checkinsExport: 'checkins/export',
    bookingsExport: 'bookings/export',
    checkinDetail: 'checkin/:uuid',
    checkinStats: 'checkins/stats',
    checkinStatsExport: 'checkins/stats/export',
    hotels: 'hotels',
    getOneHotel: 'hotel/',
    salesChannels: 'sales-channels',
    updateSalesChannel: 'sales-channels/update/:id',
    createPremiumSuscription: 'stripe/create-premium-suscription',
    iHClientHotel: 'ih-client-hotel',
    appearence: 'hotel/:hotelId/appearance',
    setCarouselUrl: 'hotel/:hotelId/appearance/set-carousel-url',
    appearenceUpdate: 'hotel/appearance',
    languages: 'languages',
    allHotels: 'all-hotels',
    pmsHotels: 'pms/hotels',
    pmsList: 'pms/list',
    pmsPublicList: 'pms/public-list',
    pmsConfigHotel: 'pms/config-hotel',
    pmsOauth: 'pms/oauth',
    pmsConfig: 'pms/config/:pmsId',
    pmsConfigDynamicForm: 'pms/configDynamicForm/:pmsId',
    pmsConfigDynamicFormByHotelId: 'pms/configDynamicFormByHotelId/:hotelId',
    pmsConfigUpdate: 'pms/config/:hotelId',
    pmsConnectionCheck: 'pms/connection-check/:hotelId',
    pmsBookingCheck: 'health-check/autocheckin/:hotelId',
    pmsConfigFile: 'pms/processPMSFile/:pmsId',
    checkinConfig: 'config/checkin/:hotelId',
    updateCheckinConfig: 'config/checkin',
    bookingSearchConfig: 'config/booking-search/:hotelId',
    updateBookingSearch: 'config/booking-search',
    bookings: 'bookings',
    guestForms: 'forms/:hotelId',
    updateForms: 'forms',
    setFormsVersion: 'forms/version/:hotelId',
    copyFormConfig: 'forms/copy/:hotelId',
    getCopyFormConfigCompatibility: 'forms/copy/compatibility/:hotelId',
    legalTexts: 'legal-texts/:hotelId',
    updateLegalText: 'legal-texts',
    communicationChannels: 'communication-channels/:hotelId',
    communicationEmails: 'communication-emails',
    user: 'user',
    updateUser: 'user/chain',
    owner: 'user/owner',
    usersList: 'user/list',
    sendUserInvitation: 'user/send-invitation',
    deleteUser: 'user/delete/:userId',
    updateAppearenceChain: 'chain/:chainId/appearance',
    medias: 'medias/view',
    createOtaMarketing: 'ota-marketing/create',
    quickguideImages: 'aws/quickguide-images',
    finishQuickguide: 'user/finish-quickguide',
    getPaymentMethods: 'stripe/get-payment-methods/:userId',
    createPaymentMethod: 'stripe/create-payment-method',
    doorsOpeningByHotelList: 'doors/:hotelId/list',
    addDoorOpeningToHotel: 'doors/:hotelId/add',
    updateDoorOpeningToHotel: 'doors/:hotelId/update/:doorId',
    deleteDoorOpeningToHotel: 'doors/:hotelId/delete/:doorId',
    importDoorOpeningToHotel: 'doors/:hotelId/import',
    paymentsList: 'payment/list',
    hotelPaymentConfig: 'payment/config/:platform',
    updateHotelPaymentConfig: 'payment/hotel-platform-config/:hotelId',
    hotelsSelectedPayment: 'payment/hotels-platform',
    doorOpeningDownloadTemplate: 'doors/download-template',
    doorOpeningList: 'doors/enabled-integrations',
    doorOpeningHotels: 'doors/hotel-doors',
    doorOpeningConfig: 'doors/config/:platform',
    updateDoorOpeningConfig: 'doors/hotel-platform-config/:hotelId',
    accountFunctionalities: 'account/functionalities/:hotelId',
    requestFunctionalityContract: 'account/request-functionality-contract/:hotelId',
    sendRequestFuncionalityEmail: 'account/send-request-functionality-email/:hotelId',
    mailTemplates: 'guestlink/:hotelId',
    updateMailTemplateStatus: 'guestlink/:hotelId/update-status',
    mailTemplateDetail: 'guestlink/:hotelId/detail/:guestlinkId',
    getTags: 'tags',
    sendTestEmail: 'guestlink/send-test-email',
    uploadMailAttachments: 'medias/create',
    updateMailTemplate: 'guestlink/:hotelId/update/:guestlinkId',
    guestlinkOptions: 'guestlink/:hotelId/options',
    createGuestlink: 'guestlink/:hotelId/create',
    deleteGuestlink: 'guestlink/:hotelId/delete/:guestlinkId',
    purchasesList: 'purchases',
    purchasesExport: 'purchases/export',
    getEstablishmentTypes: 'establishment-types',
    paperlessPush: 'paperless-push',
    policeReport: 'police-reports',
    policeReportDetail: 'police-reports/detail',
    sendPoliceReport: 'police-reports/:guestId',
    policeReportDownloadTrigger: 'police-reports/download/trigger',
    downloadPoliceReports: 'ses-file',
    policeReportConfig: 'config/:hotelId',
    bookingReportConfig: 'bookingReportConfig/:hotelId',
    policeReportSFTP: 'SFTP-config/:hotelId',
    policeReportSES: 'SES-config/:hotelId',
    policeReportERTZ: 'ERTZ-config/:hotelId',
    policeReportMOSSOS: 'MOSSOS-config/:hotelId',
    policeReportDeleteERTZFile: 'ERTZ-deleteFile/:hotelId',
    policeReportUploadERTZFile: 'ERTZ-file/:hotelId',
    policeReportDownloadFiles: 'police-report/download/getFiles',
    sendPoliceReportAllErrors: 'police-report/sendAllErrors',
    sendPoliceReportDelete: 'police-report/download/deleteFromMongo',
    upsellSendEmailToHotel: 'booking/upsell',
    upsellSendEmailToGuestApproved: 'booking/upsell',
    upsellSendEmailToGuestRejected: 'booking/upsell',
    sellAddPMSNote: 'checkin/v1/:hotelId/upselling-pms-note',
    upsellAddPMSNote: 'checkin/v1/:hotelId/upselling-pms-note',
    upsellUpdateCharges: 'payment/v1/:hotelId/upsell-update-charges',
    crossSellSendEmail: 'booking/cross-sell',
    crossSellUpdateCharges: 'payment/v1/:hotelId/cross-sell-update-charges',
    guestlinkSmtpConfig: 'guestlink/smtp/config/:hotelId',
    updateGuestlinkSmtConfig: 'guestlink/smtp/config/update/:hotelId',
    guestlinkSmtpAuthConfig: 'guestlink/smtp/auth/config/:hotelId',
    updateGuestlinkSmtpAuthConfig: 'guestlink/smtp/auth/config/update/:hotelId',
    checkSmtpConnection: 'guestlink/smtp/check-connection',
    googleAuthApi: 'guestlink/smtp/auth/google-auth',
    getBillingInformation: 'billing/getBillingInformation',
    saveBillingInformation: 'billing/saveBillingInformation',
    handleSuscription: 'account/handle-suscription/:module',
    paymentSuscriptionStatus: 'payment/suscription-status/:hotelId',
    doorOpeningSuscriptionStatus: 'doors/suscription-status/:hotelId',
    guestlinkSuscriptionStatus: 'guestlink/:hotelId/suscription-status',
    checkinSuscriptionStatus: 'checkins/suscription-status/:hotelId',
    getHotelContractList: 'billing/getHotelContractList',
    getHotelContractFileURL: 'billing/getHotelContractFileUrl/:hotelContractId',
    createHotelContract: 'billing/createHotelContract',
    deleteHotelContract: 'billing/removeHotelContract/:hotelContractId',
    editHotelContract: 'billing/updateHotelContract/:hotelContractId',
    getHotelLicencesList: 'billing/getHotelLicenceList',
    updateHotelLicenceEnd: 'billing/updateHotelLicenceEnd',
    getHotelBillingConfiguration: 'billing/getConfiguration',
    deleteHotelLicence: 'billing/removeHotelLicence/:hotelLicenceId',
    saveBulkHotelLicence: 'billing/saveBulkHotelLicence',
    editHotelLicence: 'billing/updateHotelLicence/:hotelLicenceId',
    getHotelInvoiceFileURL: 'billing/getHotelInvoiceFileUrl/:hotelInvoiceId',
    getHotelInvoicesList: 'billing/getHotelInvoiceList',
    deleteHotelInvoice: 'billing/removeHotelInvoice/:hotelInvoiceId',
    saveHotelInvoice: 'billing/createHotelInvoice',
    editHotelInvoice: 'billing/updateHotelInvoice/:hotelInvoiceId',
    findHotelInvoiceByInvoiceId: 'billing/getHotelInvoice/:hotelInvoiceId',
    findHotelInvoiceByInvoiceInternalId: 'billing/getHotelInvoiceByInternalId/:hotelInvoiceId',
    updateHotelStatusId: 'hotel/change_status/:hotelId',
    policeReportCheckSFTPConnection: 'police-report/validations/checkSftp',
    policeReportCheckS3Connection: 'police-report/validations/checkS3',
    policeReportValidateFileExport: 'police-report/validations/fileExport',
    policeReportValidateFileExportS3: 'police-report/validations/fileExportS3',
    addReservation: 'reservations/v1',
    formFieldsInference: 'formFieldsInference/:hotelId',
    policeReportCheckSESConnection: 'police-report/validations/checkSES',
    uploadSliderImage: 'hotel/:hotelId/uploadSliderImage',
    removeSliderImage: 'hotel/:hotelId/removeSliderImage/:uid',
    getActiveDashboardAlerts: 'get-dashboard-alerts',
    registerDashboardAction: 'register-external-action',
    unblockUserRequest: 'user/unblock/:userId',
    pmsGetHardCheckinValues: 'pms/GetHardCheckin/:hotelId',
    pmsUpdateHardCheckin: 'pms/UpdateHardCheckin',
    getPaperlessDevices: 'paperless-push/getPaperlessDevices/:hotelId',
    deletePaperlessDevice: 'paperless-push/deletePaperlessDevice/device/:deviceUUID',
    getPaperlessUserHotels: 'sales-channels/getPaperlessUserHotels/:email',
    updatePaperlessUserHotels: 'sales-channels/updatePaperlessUserHotels',
    updateDevice: 'paperless-push/updateDevice',
    getApiCredentials: 'paperless-push/getApiCredentials',
    checkApiCredentials: 'paperless-push/checkApiCredentials/:hotelId',
    getAccountActiveFunctionalities: 'account/getHotelSubscriptions',
    autoCreatePaperlessUser: 'sales-channels/autoCreatePaperlessUser',
    generatePreviewPdf: 'legal-documents/generate-preview-pdf',
    getHotelCheckinConfig: 'config/getHotelCheckinConfig/:hotelId',
    updateHotelCheckinConfig: 'config/updateHotelCheckinConfig',
    getHotelTexts: 'getHotel-texts/:hotelId',
    updateHotelTexts: 'updateHotel-texts',
    getSftpConfig: 'sftp/getSftpConfig/:hotelId',
    updateSftpConfig: 'sftp/updateSftpConfig',
    checkSftpConnection: 'sftp/checkConnection',
    hotelsFile: 'hotel/processHotelsFile',
    send2fa: '2fa/send',
    confirm2fa: '2fa/confirm',
    hbxChannelChangeStatus:
      'hbx-checkin/channels/config/channel-status/:action/:hotelId/:channelId',
    hbxChannelHotelActive: 'hbx-checkin/channels/config/channel-hotel-active/:hotelId',
    hbxChannelHotelFields: 'hbx-checkin/channels/config/form-fields/:hotelId/:channelId',
    hbxChannels: 'hbx-checkin/channels',
    hbxChannelSelectOptions: 'hbx-checkin/channels/select-options',
    hbxChannelSaveConfig: 'hbx-checkin/channels/config/:hotelId/:channelId',
    createBooking: 'hotel/:hotelId/createBooking',
    updateBookingStatus: 'hotel/:hotelId/booking/:bookingId',
    bookingReportList: 'bookingReport',
    bookingReportDetail: 'bookingReport/detail',
    sendBookingReport: 'bookingReport/updateOne',
    forceBookingReport: 'bookingReport/download/trigger',
    bookingReportDelete: 'bookingReport/delete',
    guestHbxProductSuscriptionStatus: 'hbx-checkin/:hotelId/product/:nameProduct/subscribe-status',
    hbxOptIn: 'hbx-checkin/product/optin',
    hbxOptOut: 'hbx-checkin/product/optout',
    bookingReportGetFiles: 'bookingReport/download/getFiles',
    customerList: 'customer/list',
    sendCustomerInvitation: 'customer/register-via-sourcing',
    invoiceUploadDocumentTemplate: 'hbx-checkin/invoice/:chainId/:hotelId/:lang/upload-document',
    invoiceUploadInvoiceSample: 'hbx-checkin/invoice/:chainId/:hotelId/upload-invoice-sample',
    invoiceTemplateDeleteFile: 'hbx-checkin/invoice/:chainId/:hotelId/:type/delete-invoice-sample',
    invoiceTemplateCheckFileExists:
      'hbx-checkin/invoice/:chainId/:hotelId/:type/get-invoice-sample',
    invoiceGetDocumentTemplate: 'hbx-checkin/invoice/:chainId/:hotelId/:lang/get-document',
    invoiceGetListTemplate: 'hbx-checkin/invoice/:chainId/:hotelId/get-list-templates',
    invoiceDeleteDocumentTemplate: 'hbx-checkin/invoice/:chainId/:hotelId/:lang/delete-document',
    getInvoiceSFTP: 'hbx-checkin/invoice/getSFPTConfig/:hotelId',
    saveInvoiceSFTP: 'hbx-checkin/invoice/saveSFPTConfig/:hotelId',
    saveS3Users: 'hbx-checkin/saveS3Users',
    getS3Users: 'hbx-checkin/getS3Users/:hotelId',
    deleteS3Users: 'hbx-checkin/deleteS3Users/:hotelId',
    checkInvoiceSFTPConnection: 'hbx-checkin/invoice/checkSFTPConnection',
    policeReportS3userConfig: 'police-report/s3UserConfig/:hotelId',
    policeReportCreateS3User: 'police-report/createS3User',
    policeReportAlloggiati: 'police-reports/Alloggiati-config/:hotelId',
  },
  bookingOauth,
  cloudbedsOauth: 'https://hotels.cloudbeds.com/api/v1.1/access_token',
};
